import React, { useEffect, useState, useContext } from "react";
import Row from "../Row";
import Column from "../Column";
import jobContext from "src/context/jobContext";
import { useLocation } from "react-router-dom";

const Table20 = ({ setStressScore, stressScore, reload }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");
  const [data, setData] = useState([])
  const { setGreadingScore } = useContext(jobContext)

  useEffect(() => {
    const items = JSON.parse(localStorage?.data)?.[jobId]?.stress;
    if (items) {
      const masouliat = items[Object.keys(items)[0]];
      const masouliatData = [
        { name: "سطح یک", score: 8, isSelected: masouliat.value == 0 },
        { name: "سطح دو", score: 16, isSelected: masouliat.value == 1 },
        { name: "سطح سه", score: 24, isSelected: masouliat.value == 2 },
        { name: "سطح چهار", score: 32, isSelected: masouliat.value == 3 },
        { name: "سطح پنج", score: 40, isSelected: masouliat.value == 4 },
      ]

      setData(masouliatData)

      const selectedItem = masouliatData.find((i) => i.isSelected)?.score
      setStressScore(selectedItem)
      setGreadingScore((prev) => ({ ...prev, "stress": selectedItem }))
    }
  }, [reload])
  return (
    <div>
      <Row type={1}>
        <Column>سطح 1</Column>
        <Column>سطح 2</Column>
        <Column>سطح 3</Column>
        <Column>سطح 4</Column>
        <Column>سطح 5</Column>
      </Row>
      <Row type={2}>
        <Column paddingY={30}>
          ضرورت حضور در محل
          کار یا تماس تلفنی در
          خارج از وقت اداری در
          حداقل دفعاتی که
          موجب اندکی نگرانی و
          سلب آسایش شود
        </Column>
        <Column paddingY={30}>
          استرس کم و ابهام و
          تضاد در نقش کم، تضاد
          در کار و خانواده کم و
          ضرورت حضور و تماس
          تلفنی خارج از وقت
          اداری به دفعات کم که
          کمی موجب نگرانی می
          شود.
        </Column>
        <Column paddingY={30}>
          استرس، ابهام و تضاد
          کم، تماس تلفنی
          خارج از ساعات
          اداری به دفعات زیاد
          و آماده بکار بودن در
          خارج از ساعات
          اداری
        </Column>
        <Column paddingY={30}>
          استرس، ابهام و تضاد
          متوسط، ضرورت
          حضور در محل کار
          خارج از ساعات
          اداری به دفعات زیاد
          که موجب سلب
          آسایش می شود
        </Column>
        <Column paddingY={30}>
          استرس، ابهام و تضاد
          زیاد، ضرورت حضور در خارج از ساعات کاری
          بسیار بالا و در طول شبانه
          روز باعث سلب آسایش
          می شود.
        </Column>
      </Row>
      <Row>
        <Column isActive={stressScore == 8}>8</Column>
        <Column isActive={stressScore == 16}>16</Column>
        <Column isActive={stressScore == 24}>24</Column>
        <Column isActive={stressScore == 32}>32</Column>
        <Column isActive={stressScore == 40}>40</Column>
      </Row>
    </div>
  );
};

export default Table20;
